import {
  __esm
} from "./chunk-ZU6LNBSF.mjs";

// src/utils/classnames.ts
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}
var init_classnames = __esm({
  "src/utils/classnames.ts"() {
  }
});

export {
  cn,
  init_classnames
};
